import {Content} from '@volkswagen-onehub/fa-content-service';
import React from 'react';
import {useFeatureServices} from './use-feature-services';
import LocatorApp from './components/locator-app';

export function App(): JSX.Element {
  const {
    'locale-service': localeService,
    'tracking': trackingManager,
    'fa-content-service': contentService,
  } = useFeatureServices();

  const content: Content = contentService?.content ?? {search_type: undefined};
  const search_type =
    'search_type' in content ? content.search_type : undefined;

  React.useEffect(() => console.log('React.version', React.version), []);

  return (
    <LocatorApp
      language={localeService}
      trackingService={trackingManager}
      search_type={search_type as string | null}
    />
  );
}
